import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M17.5 21v-3M17.5 16v-3M17.5 11V8M17.5 6V3M5.5 6V3M7.5 11V8M9.5 16v-3M12.5 21v-3M18 20.5h-2M14 18.5h-2M14 20.5h-2M18 18.5h-2M18 15.5h-2M18 13.5h-2M18 10.5h-2M18 5.5h-2M18 3.5h-2M11 13.5H9M11 15.5H9M9 8.5H7M18 8.5h-2M9 10.5H7M7 5.5H5M7 3.5H5M2 21.5h20" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }